import { ApiService } from "./ApiService"

export class InvoiceSubscriptionService {

    static uri = '/invoice-subscription';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static show({id}) {
        return ApiService.get(`${this.uri}/show/${id}`,{
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static create({data}) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                'Content-Type': 'application/json'
            }
        });
    }

    static sendBatch({data}) {
        return ApiService.post(`${this.uri}/send-batch`, {invoice_ids: data}, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                'Content-Type': 'application/json'
            }
        });
    }

    static sendSingle({invoiceId}) {
        return ApiService.post(`${this.uri}/send-single/${invoiceId}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                'Content-Type': 'application/json'
            }
        });
    }

    static preview({invoiceId}) {
        return ApiService.get(`${this.uri}/preview/${invoiceId}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                'Content-Type': 'application/json'
            }
        });
    }
}